import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './Checkbox.module.scss';

function Checkbox(props) {
  const {
    id,
    label,
    value,
    handler,
    filterKey,
    onChange,
    indeterminate,
    inline = false,
    checked = false,
    disabled = false,
    shouldUseModernStyles = false,
  } = props;

  const checkboxRef = useRef(null);

  useEffect(() => {
    if (checkboxRef.current) {
      checkboxRef.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);

  const handleChange = (e) => {
    const current = e.target.checked;

    if (handler) {
      const state = { [value]: current };
      if (filterKey) {
        handler(filterKey, state);
      } else {
        handler(state);
      }
    }

    if (onChange) {
      onChange(current, value);
    }
  };

  const formattedLabel = (value, count) => {
    const { colorLabel } = props;

    return (
      <div className={styles.data_results}>
        <span className={cn(styles.formattedLabel, colorLabel ? styles[colorLabel] : '')}>{value}</span>

        {count && <span className={cn(styles.count, count === 0 ? styles.zero : '')}>{count}</span>}
      </div>
    );
  };

  return (
    <label
      className={cn(styles.container, {
        [styles.inline]: inline,
        [styles.modern]: shouldUseModernStyles,
      })}
    >
      <input
        type="checkbox"
        id={id ? id : value}
        value={value}
        ref={checkboxRef}
        checked={checked}
        onChange={handleChange}
        className={styles.checkboxInput}
        disabled={disabled}
      />

      <div
        className={cn(
          styles.checkboxIcon,
          !shouldUseModernStyles &&
            (disabled ? 'cymbio-checkbox-disabled' : checked ? 'cymbio-checkbox' : 'cymbio-checkbox-outline'),
        )}
      />

      {props.hideLabel ? null : (
        <span className={styles.label}>{formattedLabel(label ? label : value, props.counter)}</span>
      )}
    </label>
  );
}

export default Checkbox;

Checkbox.propTypes = {
  value: PropTypes.string.isRequired,
  counter: PropTypes.number,
  handler: PropTypes.func,
  filterKey: PropTypes.string,
  hideLabel: PropTypes.bool,
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  id: PropTypes.string,
  colorLabel: PropTypes.string,
  label: PropTypes.string,
  inline: PropTypes.bool,
  disabled: PropTypes.bool,
  shouldUseModernStyles: PropTypes.bool,
  indeterminate: PropTypes.bool,
};
